export const SettingsRoutes = [
  {
    index: true,
    alias: 'settings',
    lazy: () => import('./settings.page'),
  },
] as const
